<template>
  <v-container class="px-0 py-0">

    <div v-if="!loading">

      <v-btn class="my-2" text color="orange" @click="$router.push({name:'ManageContent', params: {tag: dashboardTag}})">< Back</v-btn>
      <v-card v-if="deckDetails.public" class="text-center pa-2" dark color="blue lighten-2">This deck is published</v-card>

      <v-card class="pa-3">
        <v-layout wrap>
          <v-flex xs10 class class="ml-3 my-5">
            <span v-if="!editName" class="headline">
              {{deckDetails.name}}
              <v-btn class="ml-3" color="grey" icon small @click="editName = true" >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </span>
            <span v-if="editName">
                <v-layout>
                  <v-flex xs10>
                    <v-text-field label="Name" v-model="deckDetails.name"></v-text-field>
                  </v-flex>
                  <f-flex xs2 class="mt-4">
                    <v-btn icon @click="saveName">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-btn icon @click="editName = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </f-flex>
                </v-layout>
            </span>
          </v-flex>

          <v-flex x12 >
            <v-switch
              label="Published"
              v-model="deckDetails.public"
              @change="saveDeckProp('public')"
              large
            ></v-switch>
          </v-flex>

        </v-layout>


        <v-layout wrap class="my-5">
          <v-flex xs12 sm4>
              <v-select
                class="mx-2"
                label="Subject"
                :items="$store.state.contentProps.subjects"
                v-model="deckDetails.subject"
                @change="saveDeckProp('subject')"
                outlined
                ></v-select>
          </v-flex>
          <v-flex xs12 sm4>
              <v-text-field
                class="mx-2"
                label="Lecture Date"
                v-model="deckDetails.lectureDate"
                @change="saveDeckProp('lectureDate')"
                type="date"
                outlined
                ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
              <v-select
                class="mx-2"
                label="Editors"
                v-model="deckDetails.editors"
                @change="saveDeckProp('editors')"
                :items="$store.state.editors"
                item-text="fullname"
                item-value="id"
                multiple
                outlined
                ></v-select>

          </v-flex>
          <v-flex xs12 sm4>
              <v-select
                class="mx-2"
                chips
                label="Domain Restriction"
                v-model="deckDetails.domainAuth"
                @change="saveDeckProp('domainAuth')"
                :items="$store.state.contentProps.domains"
                multiple
                outlined
                ></v-select>

          </v-flex>
          <v-flex xs12 sm6>
              <v-combobox
                multiple
                clearable
                label="Tags"
                outlined
                chips
                :items="$store.state.contentProps.tags"
                v-model="deckDetails.tags"
                class="mx-2"
                @change="saveTags()"
              ></v-combobox>
          </v-flex>
        </v-layout>

      </v-card>
      <div>
        <v-card class="py-3 px-1 mt-2">
          <span class="px-2 py-5 headline">Content</span>
          <v-btn class="ma-2" fab dark color="orange" @click="addNewCard">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <div v-for="card, index in cards" :id="card.id">

            <div v-if="card.type == 'question_answer'">
              <v-card class="py-2 px-2" color="orange lighten-4" flat outlined>Question {{cards.length - index}}
                <span class="orange--text text--lighten-2">(id={{card.id}})</span>
                <v-btn class="float-right" small icon @click="editCardContent(card)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
              </v-card>
              <v-layout row wrap class="px-3 py-1">
                <v-flex class="px-2 grey--text" xs6 md3>Question</v-flex>
                <v-flex class="px-2 grey--text" xs6 md3>Question Image</v-flex>
                <v-flex class="px-2 grey--text hidden-sm-and-down" xs6 md3>Answer</v-flex>
                <v-flex class="px-2 grey--text hidden-sm-and-down" xs6 md3>Answer Image</v-flex>
              </v-layout>
              <v-layout row wrap class="pa-3">
                <v-flex v-html="card.question" class="blue--text pa-2" xs6 md3></v-flex>
                <v-flex class="px-2" xs6 md3><img width="100%" :src='card.question_image'></v-flex>
                <v-flex class="px-2 grey--text hidden-md-and-up" xs6 md3>Answer</v-flex>
                <v-flex class="px-2 grey--text hidden-md-and-up" xs6 md3>Answer Image</v-flex>
                <v-flex v-html="card.answer" class="pa-2" xs6 md3></v-flex>
                <v-flex class="px-2 text-right" xs6 md3>

                  <img width="100%" :src='card.answer_image'>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="pa-3" v-if="card.learnMore != '' || card.learnMore_image != ''">
                <v-flex xs12><v-card class="py-1 px-2" flat color="blue lighten-5">Learn More</v-card></v-flex>
                <v-flex v-html="card.learnMore" class="pa-2" xs6></v-flex>
                <v-flex class="px-2" xs6><img width="100%" :src='card.learnMore_image'></v-flex>
                </v-flex>
              </v-layout>
            </div>

            <div v-if="card.type == 'labeled_image'">
              <v-card>
                Question {{cards.length - index}} | {{card.type}}
                <v-btn class="float-right" small icon @click="editCardContent(card)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                <div>Image: {{card.image}}</div>
                <img style="max-width:200px;" :src="card.image">
                <div>Annotation: {{card.annotation}}</div>
                <img style="max-width:200px;" :src="card.annotation">
                <div>Description: {{card.description}}</div>
                <div>Entries: {{card.entries}}</div>


              </v-card>
            </div>


          </div>

        </v-card>
      </div>
      <v-btn class="my-5 float-right" color="red" dark outlined @click="deleteDeck">
        Delete Deck
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </div>
    <EditCard @reloadCards="" ref="editCard" :card="cardSelectedForEditing"/>

    <v-progress-circular v-if="loading" class="center-element" large indeterminate :size="90" :width="15" color="orange"></v-progress-circular>
  </v-container>

</template>

<script>
import db from '@/fb'
import EditCard from '@/components/EditCard.vue'
import firebase from 'firebase'

export default {
  name: 'ManageDeck',
  components: {
    EditCard,

  },
  data() {
    return {
      loading: false,
      deckId: null,
      deckDetails: null,
      totalCardsPracticed: null,
      cards: [],
      cardSelectedForEditing: null,
      editName: false,
    }
  },

  mounted() {
    this.loading = true
    this.deckId = this.$route.params.id
    Promise.all([
      this.getDeckDetails(this.deckId),
      //this.getIndividualCards(this.deckId) -- moved to subscribed model below
    ]).then(() => {
      this.loading = false



    })

    //Monitor for changes in deck and cards for deck package
    firebase.firestore().collection('decks')
    .doc(this.deckId)
    .onSnapshot((doc) => {
      this.deckDetails = doc.data()
      this.deckDetails.id = doc.id
      if (this.deckDetails.public) {
        this.saveDeckPackage()
      }
    })
    firebase.firestore().collection('cards')
    .where('deck', '==', this.deckId)
    .onSnapshot(() => {
      this.getIndividualCards(this.deckId).then(()=> {
        if (this.deckDetails.public) {
          this.saveDeckPackage()
        }
        //check to see if need to jump to specific item
        if(this.$route.query.card != null) {
          let editItem = document.getElementById(this.$route.query.card)
          editItem.scrollIntoView()

        }
      })

    })

  },
  methods: {
    //create user facing DeckPackage
    saveDeckPackage(){
      firebase.firestore().collection('deckPackages')
      .doc(this.deckId)
      .set({
        id: this.deckId,
        deckDetails: this.deckDetails,
        cards: this.cards
      })

      let browse = {}
      browse[this.deckId] = this.deckDetails

      firebase.firestore().collection('deckPackages')
      .doc('browse')
      .set(browse, { merge: true })
    },
    deleteDeckPackage(){
      firebase.firestore().collection('deckPackages')
      .doc(this.deckId)
      .delete()

      let browse = {}
      browse[this.deckId] = firebase.firestore.FieldValue.delete()

      firebase.firestore().collection('deckPackages')
      .doc('browse')
      .update(browse)
    },
    //get deck info

    getDeckDetails(id){
      return firebase.firestore().collection('decks').doc(id).get().then(doc => {
        console.log(doc.data())
        this.deckDetails = doc.data()
        this.deckDetails.id = doc.id
      })
    },
    deleteDeck() {
      confirm("Delete this deck?")
      let deckInfo = this.deckDetails
      deckInfo.id = this.deckId
      firebase.firestore().collection('deletedDecks').doc().set(deckInfo).then(() => {
        firebase.firestore().collection('decks').doc(this.deckId).delete()
        .then(result => {
          this.$router.push({name: 'ManageContent'})
        })
        .catch(err => {
          this.$store.commit('snackbarMessageSet', {
            color: 'red lighten-1',
            message: err
          })
        })
      })
      .catch(err => {
        this.$store.commit('snackbarMessageSet', {
          color: 'red lighten-1',
          message: err
        })
      })

    },
    getIndividualCards(deckId) {
      this.cards = []
      return firebase.firestore().collection('cards').where('deck', '==', deckId).orderBy('created', 'desc').get().then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          this.cards.push(item)
        })
        this.setDeckSize()
      })
    },
    addNewCard() {
      this.cardSelectedForEditing = null
      this.$refs.editCard.openDialog()
    },
    editCardContent(card){
      this.cardSelectedForEditing = card
      this.$refs.editCard.openDialog()
    },
    saveName() {
      firebase.firestore().collection('decks').doc(this.deckId).update({
        name: this.deckDetails.name
      })
      .then(() => {
        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'green lighten-1',
          message: 'Saved ' + 'name' + ' update.'
        })
      })
      this.editName = false
    },
    setDeckSize() {
      let count = 0
      this.cards.forEach(card => {
        if (card.type == 'question_answer') {
          count += 1
        }
        else if (card.type == 'labeled_image') {
          count += card.entries.length
        }
      })
      firebase.firestore().collection('decks').doc(this.deckId).update({

        deckLength: count
      })
    },
    saveDeckProp(prop) {
      let ref = firebase.firestore().collection('decks').doc(this.deckId)
      let updates = {}
      updates[prop] = this.deckDetails[prop]
      ref.update(updates)
      .then(() => {
        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'green lighten-1',
          message: 'Saved ' + prop + ' update.'
        })
        //allows for deleting of deckPackage when unpublishing
        if (prop == 'public' && this.deckDetails.public == false) {
          this.deleteDeckPackage()
        }
      })
    },
    saveTags() {
      let ref = firebase.firestore().collection('content').doc('config')
      this.deckDetails.tags.forEach(tag => {
        if ( !(this.$store.state.contentProps.tags.includes(tag)) ) {
          ref.update({
            tags: firebase.firestore.FieldValue.arrayUnion(tag)
          })
        }
      })
      this.saveDeckProp('tags')
    }
  }
}

</script>

<style>
.center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
